// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__CacSK","error":"Textarea_error__d5HZk","readonly":"Textarea_readonly__2wjKa","disabled":"Textarea_disabled__28iUZ"};